<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <card>
          <template slot="header">
            <h4 class="card-title">外送條件與運費設定</h4>
            <h6>設定說明:</h6>
            <p v-if="user.type === 'gaa'">1. 設定物流串接方式與物流業者資訊，並設定進階門檻</p>
            <p v-if="user.type !== 'gaa'">1. 外送方式設定若為「自送」或物流業者帳號為「店家自有物流帳號」時，可設定進階門檻</p>            
            <p>2. 當符合多樣種門檻條件時，會套用第一個符合的條件</p>

            <div v-if="user.type === 'gaa'">
              <hr />
              <div v-if="settings && configurations">
                <div class="el-row">
                  <el-col :span="12">
                    <div class="el-row">
                    <el-col :span="24">
                    <h6 class="sub-title my-2"> 外送版本</h6>
                    </el-col>
                    <el-col :span="12">
                      <n-radio name="logistic-version" v-model="configurations.logisticVersion" label="v2">新版外送</n-radio>
                    </el-col>
                    <el-col :span="12">
                      <n-radio name="logistic-version" v-model="configurations.logisticVersion" label="v1">舊版外送</n-radio>
                    </el-col>
                    </div>
                  </el-col>
                </div>
                <div class="el-row">
                  <el-col :span="12" v-if="configurations.logisticVersion == 'v2'">
                    <div class="el-row">
                    <el-col :span="24">
                    <h6 class="sub-title my-2"> 是否串接物流平台</h6>
                    </el-col>
                    <el-col :span="12">
                      <n-radio name="logistic-version" v-model="configurations.logisticPlatform" label="platform">串接物流平台</n-radio>
                    </el-col>
                    <el-col :span="12">
                      <n-radio name="logistic-version" v-model="configurations.logisticPlatform" label="selfie">自送</n-radio>
                    </el-col>
                    </div>
                  </el-col>
                </div>

                <div class="el-row">
                  <el-col :span="12" v-if="configurations.logisticVersion == 'v2' && configurations.logisticPlatform === 'platform'">
                     <div class="el-row my-2">
                      <el-col :span="24">
                      <h6 class="sub-title"> 物流帳號</h6>
                      </el-col>
                      <el-col :span="12">
                        <n-radio name="logistic-wallet" v-model="configurations.logisticWallet" label="private">自有物流帳號</n-radio>
                      </el-col>
                      <el-col :span="12">
                        <n-radio name="logistic-wallet" v-model="configurations.logisticWallet" label="public" disabled>快一點帳號</n-radio>
                      </el-col>
                    </div>
                  </el-col>

                  <el-col :span="12" v-if="configurations.logisticVersion == 'v2' && configurations.logisticPlatform === 'platform'">
                    <div class="el-row my-2">
                      <el-col :span="24">
                      <h6 class="sub-title"> 拋單模式</h6>
                      </el-col>
                      <el-col :span="8">
                        <n-radio name="logistic-mode" v-model="configurations.logisticMode" label="auto">自動</n-radio>
                      </el-col>
                      <el-col :span="8">
                        <n-radio name="logistic-mode" v-model="configurations.logisticMode" label="manual" :disabled="configurations.logisticWallet === 'public'">手動</n-radio>
                      </el-col>
                    </div>
                    </el-col>

                  

                    <el-col :span="12" v-if="configurations.logisticVersion == 'v2' && configurations.logisticPlatform === 'platform'">
                     <div class="el-row my-2">
                      <el-col :span="24">
                      <h6 class="sub-title"> 預設物流業者</h6>
                      </el-col>
                      <el-col :span="12">
                        <n-radio name="logistic-wallet" v-model="configurations.logisticDefaultVendor" label="lala">Lalamove</n-radio>
                      </el-col>
                      <el-col :span="12">
                        <n-radio name="logistic-wallet" v-model="configurations.logisticDefaultVendor" label="global">全球快遞</n-radio>
                      </el-col>
                    </div>
                    </el-col>

                </div>
                <div v-for="(s, index) in settings" :key="index">
                  <div class="el-row">
                    <el-col :span="12" v-if="configurations.logisticVersion == 'v2' &&  configurations.logisticPlatform === 'platform' && configurations.logisticWallet === 'private'">
                     <div class="el-row">
                      <el-col :span="24">
                      <h6 class="sub-title my-2 text-info"> 物流業者</h6>
                      </el-col>
                      <el-col :span="12">
                        <n-radio name="logistic-vendor" v-model="s.vendor" label="lala">Lalamove</n-radio>
                      </el-col>
                      <el-col :span="12">
                        <n-radio name="logistic-vendor" v-model="s.vendor" label="global">全球快遞</n-radio>
                      </el-col>
                    </div>
                    </el-col>

                    <el-col :span="24" v-if="configurations.logisticVersion == 'v2' && configurations.logisticPlatform === 'platform' && configurations.logisticWallet === 'private'">
                     
                      <el-col :span="24">
                        <label class="sub-title my-2 text-secondary" > 物流帳號</label>
                      </el-col>
                      <el-col :span="24">
                        <el-col :span="4" v-if="s.vendor === 'global'">
                          <label class="col-form-label"> Merchant ID</label>
                        </el-col>
                        <el-col :span="8" v-if="s.vendor === 'global'">
                          <el-input
                            type="text"
                            style="width: 200px"
                            v-model="s.merchantId"
                            label="Merchant ID"
                            autocomplete="off"
                          ></el-input>
                        </el-col>
                        
                        <el-col :span="4">
                          <label class="col-form-label"> Access Key</label>
                        </el-col>
                        <el-col :span="8">
                          <el-input
                            type="text"
                            style="width: 200px"
                            v-model="s.accessKey"
                            autocomplete="off"
                          ></el-input>
                        </el-col>

                        <el-col :span="4">
                          <label class="col-form-label"> Access Token</label>
                        </el-col>
                        <el-col :span="8">
                          <el-input
                            type="text"
                            style="width: 200px"
                            v-model="s.accessToken"
                            autocomplete="off"
                          ></el-input>
                        </el-col>

                      </el-col>
                      
                    </el-col>
                  </div>
                </div>


                  <div class="el-row my-2" v-if="configurations.logisticPlatform === 'platform' && configurations.logisticWallet === 'private'">
                    <el-col :span="12">
                      <el-button type="success" size="small" @click="settings.push({})"
                        >新增物流設定</el-button
                      >
                    </el-col>
                    
                  </div>
                  <div class="el-row text-center">
                    
                    <el-button type="danger" size="small" @click="saveLogisticSettings()"
                      >更新物流設定</el-button
                    >
                    
                  </div>


              </div>
            </div>
            
          </template>
          <!-- <p>   
          </p> -->

          <!-- Delete DIALOG -->
          <el-dialog :visible.sync="dialogs.delete.show">
            <div class="row justify-content-center">
              <div
                align="center"
                v-if="!dialogs.delete.cancel && !dialogs.delete.confirm"
              >
                <i
                  style="font-size: 100px; color: orange"
                  class="el-icon-warning-outline"
                ></i>
                <h2>請問您確定要執行此操作嗎？</h2>
                <!-- <h4>你無法復原此外送條件與運費設定！</h4> -->
                <span slot="footer" class="dialog-footer" align="center">
                  <el-button type="success" @click="removeRule"
                    >是的，請刪除</el-button
                  >
                  <el-button type="danger" @click="dialogs.delete.cancel = true"
                    >不，請保留此外送條件與運費設定</el-button
                  >
                </span>
              </div>
              <div align="center" v-if="dialogs.delete.cancel">
                <i
                  style="font-size: 100px; color: red"
                  class="el-icon-circle-close"
                ></i>
                <h2>已取消</h2>
                <h4>您的外送條件與運費設定沒有受到任何影響</h4>
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="dialogs.delete.show = false"
                    >OK</el-button
                  >
                </span>
              </div>

              <div align="center" v-if="dialogs.delete.confirm">
                <i
                  style="font-size: 100px; color: red"
                  class="el-icon-circle-check"
                ></i>
                <h2>已刪除</h2>
                <h4>
                  您的外送條件與運費設定已暫被移除，回主視窗後請按"儲存設定"以儲存最終設定
                </h4>
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="dialogs.delete.show = false"
                    >OK</el-button
                  >
                </span>
              </div>
            </div>
          </el-dialog>
          <!-- END Delete DIALOG -->
          <div class="row card-body" v-if="(configurations.isLala !== 1) || (configurations.logisticVersion === 'v2')">
            <!--使用el-form-item 時, RWD需要特別設定，不然格式可能會跑掉-->
            <el-form style="width: 100%" :model="ruleForm" ref="ruleForm">
              <div
                v-for="(rule, index) in ruleForm.ruleParams"
                v-bind:key="index"
              >
                <el-divider content-position="right">
                  <!-- <el-badge :value="index+1" class="item" type="primary"></el-badge> -->
                  <el-button
                    type="primary"
                    size="small"
                    @click="showRemoveDialog(index)"
                    title="移除設定"
                    >移除設定
                  </el-button>
                </el-divider>
                <h6 class="sub-title">物流門檻設定</h6>
                <div class="el-row">
                  <el-col :span="5">
                    <n-radio v-model="rule.type" label="map">地圖設定</n-radio>
                  </el-col>
                  <el-col :span="5">
                    <n-radio v-model="rule.type" label="distance">距離設定</n-radio>
                  </el-col>
                </div>
                <br/>
                <div class="el-row" >
                  <div v-if="rule.type === 'map'"
                    class="el-col-xs-24 el-col-sm-16 el-col-lg-12 el-col-xl-8"
                  >
                    <el-form-item
                      label="地圖名稱："
                      :prop="'ruleParams.' + index + '.name'"
                      :rules="[{ required: rule.type=='map'? true: false, message: '必填' }]"
                    >
                      <el-input
                        type="text"
                        style="width: 200px"
                        v-model="rule.name"
                        :disabled="rule.type=='distance'"
                        autocomplete="off"
                      ></el-input>
                      &nbsp;
                      <el-button type="danger" size="small" @click="rule.polygons=[]" title="清空"
                        >清空地圖設定
                      </el-button>
                      <!-- <el-button
                        type="primary"
                        size="small"
                        @click="setPolygons(index, rule.ruleId)"
                        title="選擇範圍設定"
                        :disabled="rule.type=='distance'"
                        >選擇範圍設定
                      </el-button>
                      <label>{{rule.name}}</label>-->
                      <!-- <label>{{rule.polygons}}</label>  -->
                    </el-form-item>

                  </div>

                </div>
                 <div class="el-row" v-if="rule.type === 'map'">
                
                  <div class="el-col-24">
                    
                    <GoogleMapPolygons 
                      :id="index"
                      :polygons="rule.polygons"
                      @updated="(newData) => {rule.polygons = newData}"
                    >
                    </GoogleMapPolygons>
                  </div>
                </div>
                <br/>
                <div class="el-row">
                  <div
                    class="el-col-xs-24 el-col-sm-12 el-col-lg-8 el-col-xl-6"
                  >
                    <el-form-item
                      label="距離："
                      :prop="'ruleParams.' + index + '.minDistance'"
                      :rules="[{ required: rule.type=='distance'? true: false, message: '必填' }]"
                    >
                      <el-input
                        type="number"
                        min="0"
                        style="width: 150px"
                        v-model.number="rule.minDistanceInMeter"
                        :disabled="rule.type=='map'"
                        autocomplete="off"
                      ></el-input>
                      <!-- <el-input-number min="0" v-model="rule.minDistance" autocomplete="off"></el-input-number> -->
                      &nbsp;<label>公尺至</label>
                    </el-form-item>
                  </div>

                  <div class="el-col-xs-24 el-col-sm-12 el-col-lg-8">
                    <el-form-item
                      label="距離："
                      :prop="'ruleParams.' + index + '.maxDistance'"
                      :rules="[{ required: rule.type=='distance'? true: false, message: '必填' }]"
                    >
                      <el-input
                        type="number"
                        min="0"
                        style="width: 150px"
                        v-model.number="rule.maxDistanceInMeter"
                        :disabled="rule.type=='map'"
                        autocomplete="off"
                      ></el-input>
                      <!-- <el-input-number min="0" v-model="rule.maxDistance" autocomplete="off"></el-input-number> -->
                      &nbsp;<label>公尺</label>
                    </el-form-item>
                  </div>
                </div>
                
                <p>運費設定</p>
                  <div class="el-row">
                  <div class="el-col el-col-24">
                    <el-form-item
                      label="運費："
                      :prop="'ruleParams.' + index + '.deliveryCharge'"
                      :rules="[{ required: true, message: '必填' }]"
                    >
                      <el-input
                        type="number"
                        min="0"
                        style="width: 150px"
                        v-model.number="rule.deliveryCharge"
                        autocomplete="off"
                      ></el-input>
                      <!-- <el-input-number min="0" v-model="rule.deliveryCharge" autocomplete="off"></el-input-number> -->
                      &nbsp;<label>元</label>
                    </el-form-item>
                  </div>
                  <div v-if="configurations.logisticVersion === 'v2'" class="el-col el-col-24">
                    <el-form-item
                      label="運送時間："
                      :prop="'ruleParams.' + index + '.additionalDeliveryTime'"
                      :rules="[{ required: true, message: '必填' }]"
                    >
                      <el-input
                        type="number"
                        min="0"
                        style="width: 150px"
                        v-model.number="rule.additionalDeliveryTime"
                        autocomplete="off"
                      ></el-input>
                      <!-- <el-input-number min="0" v-model="rule.deliveryCharge" autocomplete="off"></el-input-number> -->
                      &nbsp;<label>分鐘</label>
                    </el-form-item>
                  </div>
                </div>
                <br />
                <p>運送門檻設定</p>
                <div class="el-row">
                  <div class="el-col el-col-24">
                    <el-form-item
                      label="金額："
                      :prop="'ruleParams.' + index + '.amountLimit'"
                    >
                      <el-input
                        type="number"
                        min="0"
                        style="width: 150px"
                        v-model.number="rule.amountLimit"
                        autocomplete="off"
                      ></el-input>
                      <!-- <el-input-number min="0" v-model="rule.amountLimit" autocomplete="off"></el-input-number> -->
                      &nbsp;<label>元以上</label>
                    </el-form-item>
                  </div>
                  <div class="el-col el-col-24">
                    <el-form-item
                      label="數量："
                      :prop="'ruleParams.' + index + '.qtyLimit'"
                    >
                      <el-input
                        type="number"
                        min="0"
                        style="width: 150px"
                        v-model.number="rule.qtyLimit"
                        autocomplete="off"
                      ></el-input>
                      <!-- <el-input-number min="0" v-model="rule.qtyLimit" autocomplete="off"></el-input-number> -->
                      &nbsp;<label>個以上</label>
                    </el-form-item>
                  </div>
                </div>

                <br />
                <p>設定結果</p>
                <div class="el-row rule">
                  <span v-if="rule.type=='map'">{{rule.name}} 地圖設定範圍內</span>
                  <span v-if="rule.type=='distance' && rule.minDistanceInMeter >= 0 && rule.maxDistanceInMeter >= 0"
                    >{{ rule.minDistanceInMeter }} - {{ rule.maxDistanceInMeter }} 公尺
                  </span>運費
                    {{ rule.deliveryCharge }}元
                  <span v-if="rule.amountLimit"
                    >，滿 {{ rule.amountLimit }} 元以上可外送
                  </span>
                  <span v-if="rule.qtyLimit"
                    >，滿 {{ rule.qtyLimit }} 個以上可外送</span
                  >
                </div>
                <!-- <el-divider></el-divider> -->
              </div>
            </el-form>
          </div>
          <el-divider v-if="(configurations.isLala !== 1) || (configurations.logisticVersion === 'v2')"></el-divider>
          <el-button v-if="(configurations.isLala !== 1) || (configurations.isLogistic === 1)"
            type="warning"
            icon="el-icon-plus"
            size="small"
            @click="addNewRule"
            title="新增距離條件"
            :disabled="saving"
            >新增距離條件</el-button
          >
          <el-divider v-if="(configurations.isLala !== 1) || (configurations.logisticVersion === 'v2')"></el-divider>
          <div class="text-center" v-if="(configurations.isLala !== 1) || (configurations.logisticVersion === 'v2')">
            <el-button
              type="danger"
              size="small"
              @click="saveConfiguration"
              title="儲存門檻設定"
              :loading="saving"
              >儲存設定</el-button
            >
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import {
  Radio
} from "src/components/index";
import GoogleMapPolygons from "src/pages/Dashboard/Shops/GoogleMapPolygons";

export default {
  data() {
    return {
      ruleForm: {},
      // ruleParams: [],
      saving: false,
      dialogs: {
        delete: {
          show: false,
          ruleIndex: null,
          cancel: false,
          confirm: false
        }
      },
      settings: [],
      configurations: {}
    };
  },
  components: {
    [Radio.name]: Radio,
    GoogleMapPolygons
  },
  computed: {
    user: function() {
      return this.$store.getters.user;
    }
  },
  mounted() {
    this.getConfiguration();
    this.getLogisticSettings();
    let self = this;
    // window.addEventListener("message", (event) => {
    //   setTimeout(function() {
    //     self.setName(event);
    //   }, 1000);
      
    //   // console.log('pppp ', event);
    //   // if (typeof event.data.index === 'string') {
    //   //   // 為什麼好像都要多一個event才能變動到資訊呢...
    //   //   let i = parseInt(event.data.index, 10);
    //   //   self.ruleForm.ruleParams[i].polygons = event.data.allPolygons;
    //   //   self.ruleForm.ruleParams[i].name = event.data.name;
    //   // }
    //   // event.message.data == test12345

    //   // if (event.origin !== "http://example.org:8080")
    //   //   return;

    //   // // ...
    // }, false);
  },
  methods: {
    // setName(event) {
    //   let self = this;
    //   if (typeof event.data.index === 'string') {
    //     // 為什麼好像都要多一個event才能變動到資訊呢...
    //     let i = parseInt(event.data.index, 10);
    //     self.ruleForm.ruleParams[i].polygons = event.data.allPolygons;
    //     self.ruleForm.ruleParams[i].name = event.data.name;
    //   }
    // },
    // setPolygons(ruleIndex, ruleId) {
    //   let openurl = `./logistic-polygons?shop_id=${this.$route.query.shop_id}&index=${ruleIndex}`;
    //   if (ruleId)
    //     openurl += '&rule_id=' + ruleId;
    //   var newWindow = window.open(
    //    openurl,
    //   // `${process.env.VUE_APP_APIHOST}/line-notify-binding${qs}`,
    //     // `${process.env.VUE_APP_TEMPOAUTH}${qs}`,
    //     // `https://dl.gl/J4wnJROdR?shop=${this.$route.query.shop_id}&channelName=${this.model.name}&groupUrl=${this.model.url}`,
    //     "line-notify-setting",
    //     "location=no,width=800px,height=800px"
    //   );
    //   // for same origin
    //   // newWindow.onbeforeunload = this.windowClosing;

    //   let self = this;
    //   // for cross origin???????? <-- notify那邊的，這邊應該不需要？
    //   // var timer = setInterval(function() {
    //   //   if (newWindow.closed) {
    //   //     clearInterval(timer);
    //   //     self.windowClosing();
    //   //   }
    //   // }, 1000);

    // },
    addNewRule() {
      let defaultRule = {
        type: 'distance',
        name: null, 
        polygons: [],
        minDistance: 0,
        maxDistance: 0,
        minDistanceInMeter: 0,
        maxDistanceInMeter: 0,
        deliveryCharge: 0,
        additionalDeliveryTime: 0,
        qtyLimit: "",
        amountLimit: ""
      };
      // this.ruleParams.push(defaultRule);
      let index = this.ruleForm.ruleParams.length;
      // defaultRule.minDistance = this.ruleForm.ruleParams[index-1].maxDistance;
      // defaultRule.minDistanceInMeter = this.ruleForm.ruleParams[index-1].maxDistanceInMeter;
      // defaultRule.maxDistance = defaultRule.minDistance + 1;
      // defaultRule.maxDistanceInMeter = defaultRule.minDistanceInMeter + 1000;
      this.ruleForm.ruleParams.push(defaultRule);
    },
    showRemoveDialog(index) {
      this.dialogs.delete.show = true;
      this.dialogs.delete.ruleIndex = index;
      this.dialogs.delete.cancel = false;
      this.dialogs.delete.confirm = false;
    },
    removeRule() {
      let self = this;
      self.dialogs.delete.confirm = true;
      let ruleIndex = self.dialogs.delete.ruleIndex;
      self.ruleForm.ruleParams.splice(ruleIndex, 1);
    },
    saveLogisticSettings() {
      let self = this;
      if (self.configurations.logisticVersion === 'v2') {
        self.configurations.isLogistic = 1;
        self.configurations.isLala = 0;
        if (self.configurations.logisticPlatform === 'selfie') {
          self.configurations.logisticMode = 'selfie';
          self.settings = [];
        } else {
          if (self.configurations.logisticWallet === 'private') {
            if (!self.settings || !self.settings[0]) {
              alert('自有物流需新增至少一組物流業者帳號')
              throw new Error('Missing required logistic settings');
            }
          } else {
            self.settings = [];
          }
          if (!self.configurations.logisticMode || self.configurations.logisticMode === 'selfie') {
            alert('請選擇拋單模式');
            throw new Error('missing required logistic mode');
          }
        }
      } else {
        self.configurations.isLogistic = 0;
      }
      
      let data = {
        configurations: self.configurations,
        settings: self.settings
      };
      console.log(JSON.stringify(data, null, 2));
      return axios
      .put(
        `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
          this.$route.query.shop_id
        }/logistic-settings`,
        data
      )
      .then(response => {
        console.log("the data " + JSON.stringify(response.data));
        alert("儲存設定成功");
        self.getLogisticSettings()
        return response.data;
      })
      .catch(e => {
        alert("儲存失敗!!");
      });
    },
    getLogisticSettings() {
      let self = this;
      // 資料格式範例
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
            this.$route.query.shop_id
          }/logistic-settings`
        )
        .then(response => {
          console.log('settings ', response.data);
          if (!response.data)
            return;
          
          if (response.data.configurations.isLogistic)
            response.data.configurations.logisticVersion = 'v2';
          else
            response.data.configurations.logisticVersion = 'v1';

          if (!response.data.configurations.logisticMode || response.data.configurations.logisticMode === 'selfie') {
            response.data.configurations.logisticMode = 'selfie';
            response.data.configurations.logisticPlatform = 'selfie';
          } else {
            response.data.configurations.logisticPlatform = 'platform';
          }
            
          if (response.data.configurations.logisticWallet !== 'private')
            response.data.configurations.logisticWallet = 'public';

          if (response.data.configurations.logisticDefaultVendor !== 'global')
            response.data.configurations.logisticDefaultVendor = 'lala';


          self.configurations = response.data.configurations || {};

          self.settings = response.data.settings || [];
        })
        .catch((e) => {
          console.log('failed ' + e.stack);
        });
    },
    getConfiguration() {
      let self = this;
      // 資料格式範例
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
            this.$route.query.shop_id
          }/logistic-rules`
        )
        .then(response => {
          // convert km to m
          //console.log('-------------logistic-rules', response.data);
          let rules = response.data.map(function(rule) {
            // rule.minDistanceInMeter = rule.minDistance * 1000;
            // rule.maxDistanceInMeter = rule.maxDistance * 1000;
            if (!rule.hasOwnProperty('polygons')) {
              rule.polygons = [];
            }
            if (!rule.type) {
              rule.type = 'distance';
            }

            // minDistanceInMeter/maxDistanceInMeter 若未定義
            // 則根據minDistance/maxDistance的值給預設值
            if ((rule.minDistanceInMeter === null || rule.minDistanceInMeter=== undefined)  && rule.minDistance>=0) {
              rule.minDistanceInMeter = rule.minDistance * 1000;
            } 

            if ((rule.maxDistanceInMeter === null || rule.maxDistanceInMeter=== undefined) && rule.maxDistance>=0) {
              rule.maxDistanceInMeter = rule.maxDistance * 1000;
            } 
            //rule.polygons = [ [ { "x": 25.059575081675924, "y": 121.54239551744384 }, { "x": 25.058124171488362, "y": 121.5413959146764 }, { "x": 25.058551807750067, "y": 121.54478622687122 }, { "x": 25.060301213280887, "y": 121.54472185385487 }, { "x": 25.059575081675924, "y": 121.54239551744384 } ] ];
            return rule;
          });
          
          let confs = {
            // ruleParams: response.data
            ruleParams: rules
            // ruleParams: [
            //   {
            //     minDistance: 0,
            //     maxDistance: 2,
            //     deliveryCharge: 0,
            //     qtyLimit: 0,
            //     amountLimit: 0
            //   },
            //   {
            //     minDistance: 2,
            //     maxDistance: 10,
            //     deliveryCharge: 10,
            //     qtyLimit: 0,
            //     amountLimit: 100
            //   }
            // ]
          };
          // this.ruleParams = confs.ruleParams;
          self.ruleForm = confs;
          console.log('what the result? ' + JSON.stringify(self.ruleForm))
        });
    },
    saveConfiguration() {
      // 表單是否有效
      let self = this;
      self.saving = true;
      // Polygons 無法用form validation進行，所以先檢查
      for (let rule of self.ruleForm.ruleParams){
        if (rule.type == 'map' && rule.polygons.length ==0) {
          alert("無效的表單!!請圈選地圖範圍");
          //break;
          self.saving = false;
          return false;
        }
      };
      console.log("is rule form valid?", this.$refs.ruleForm.validate());
      
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // convert m to km
          let rules = this.ruleForm.ruleParams.map(function(rule) {
            rule.minDistance = rule.minDistanceInMeter / 1000;
            rule.maxDistance = rule.maxDistanceInMeter / 1000;
            return rule;
          });
          //console.log('----------ruleParms:', this.ruleForm.ruleParams)
          return axios
          .put(
            `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
              this.$route.query.shop_id
            }/logistic-rules`,
            this.ruleForm.ruleParams
          )
          .then(response => {
            console.log("the data " + JSON.stringify(response.data));
            alert("儲存設定成功");
            self.saving = false;
            self.getConfiguration()
            return response.data;
          })
          .catch(e => {
            self.saving = false;
            alert("儲存失敗!!");
          });
        } else {
          self.saving = false;
          alert("無效的表單!!");
        }
      });
      // 會把資料格式回存
      console.log("the rulesParams ?", this.ruleForm.ruleParams);
    }
  }
};
</script>

<style scoped>
.kay-data-table .btn-base,
.el-select .el-input .el-input__inner,
.btn,
.navbar .navbar-nav > a.btn {
  margin: 0px !important;
}
.rule-input-area {
  margin-bottom: 15px;
}
/* 可以設定style，讓運費設定結果顯示較明顯 */
.rule {
  /* color: darkblue; */
}
</style>
